// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"4e7206aa","842":"d41c786b"}[chunkId] + ".chunk.js";
};